import React from "react";
import IMAGES from "@/data/assetData";
import Image from "next/image";
import Button from "@/components/ui/Button";
const AccessoriesModal = ({ isModalOpen, closeModal = () => {} }) => {
  return (
    <div>
      {/* Modal */}
      {isModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-end lg:items-center justify-center bg-black/50 z-[150]">
          <div className="relative bg-white w-full lg:w-6/12 p-4 lg:p-6 rounded-t-xl lg:rounded-xl">
            {/* Close Icon */}
            <button
              className="absolute top-4 lg:top-2 right-4 lg:right-2 text-black lg:text-white hover:text-gray-700 lg:-mr-10"
              onClick={closeModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Modal Content */}
            <h2 className="text-base lg:text-xl font-medium mb-6">
              Accessories Add - Ons
            </h2>

            <div className="flex flex-wrap gap-[12px] max-h-[450px] lg:max-h-[auto] overflow-y-auto lg:overflow-visible scrollbar-style">
              {/* 40% Part - Vehicle Card */}
              {/* Vehicle Card */}
              <div className="border p-3 rounded-md flex flex-col basis-[48%] lg:basis-[auto]">
                <h2 className="text-sm lg:text-base font-medium mb-4">
                  Helmet
                </h2>
                <Image
                  width={92}
                  height={92}
                  src={IMAGES.HelmetIcon}
                  alt="Vehicle"
                  className="mb-4 rounded-md self-center"
                />
                <div className="flex justify-between ">
                  <div className="flex flex-1 items-center">
                    <h6 className="mr-3 lg:mr-6 text-sm lg:text-base font-semibold">
                      Rs. 250
                    </h6>
                    <span className="mr-3 scale-125">-</span>
                    <span className="mr-3 w-6 h-6 text-base font-medium leading-6 text-center rounded-full bg-primary text-white">
                      1
                    </span>
                    <span className="scale-125">+</span>
                  </div>
                </div>
              </div>

              <div className="border p-3 rounded-md flex flex-col basis-[48%] lg:basis-[auto]">
                <h2 className="text-sm lg:text-base font-medium mb-4">
                  Helmet
                </h2>
                <Image
                  width={92}
                  height={92}
                  src={IMAGES.HelmetIcon}
                  alt="Vehicle"
                  className="mb-4 rounded-md self-center"
                />
                <div className="flex justify-between ">
                  <div className="flex flex-1 items-center">
                    <h6 className="mr-3 lg:mr-6 text-sm lg:text-base font-semibold">
                      Rs. 250
                    </h6>
                    <span className="mr-3 scale-125">-</span>
                    <span className="mr-3 w-6 h-6 text-base font-medium leading-6 text-center rounded-full bg-primary text-white">
                      1
                    </span>
                    <span className="scale-125">+</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Buttons */}
            <div className="flex justify-center mt-4 gap-4">
              <Button variant="ghost" size="md" onClick={closeModal}>
                Cancel
              </Button>
              <Button size="md">Okay</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccessoriesModal;
